<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :items="equipamentos"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <datatable-filters
            :filters="filters"
            v-model="filtrosAtivos"
          ></datatable-filters>
          <v-divider vertical inset class="mx-4" />
          <v-spacer />
          <v-btn
            v-if="perms.includes('equipamento.editar_dados')"
            depressed
            color="accent"
            :to="{ name: 'equipamento-formulario' }"
          >
            <v-icon class="mdi mdi-plus mr-2" />Novo Cadastro
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.ativo="{ item }">
        <v-icon
          :class="
            item.ativo
              ? 'mdi mdi-checkbox-marked-outline'
              : 'mdi mdi-checkbox-blank-outline'
          "
        />
      </template>
      <template v-slot:item.actions="{ item }">
        <lista-documentos-dialog
          :title="`Documentos de ${item.descricao}`"
          :id-proprietario="item.id"
          url-base="equipamento"
        />
        <v-btn
          v-if="perms.includes('equipamento.editar_dados')"
          icon
          small
          text
          @click="editar(item.id)"
        >
          <v-icon class="mdi mdi-pencil" small />
        </v-btn>
        <dialog-confirm
          v-if="perms.includes('equipamento.editar_dados')"
          titulo="Deletar Equipamento"
          texto="Confirma a exclusão?"
          @confirmar="deletar(item.id)"
        >
          <v-btn icon small text>
            <v-icon class="mdi mdi-delete" small />
          </v-btn>
        </dialog-confirm>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import DatatableFilters from "../components/DatatableFilters";
import DialogConfirm from "../components/DialogConfirm";
import ListaDocumentosDialog from "../components/documentos/ListaDocumentosDialog";
export default {
  components: { DatatableFilters, DialogConfirm, ListaDocumentosDialog },
  data() {
    return {
      headers: [
        { text: "Código", value: "codigo" },
        { text: "Descrição", value: "descricao" },
        { text: "Capacidade", value: "capacidade" },
        { text: "Ativo", value: "ativo" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      filters: [
        {
          name: "codigo",
          label: "Código",
          type: "text",
          defaultValue: "",
        },
        {
          name: "descricao",
          label: "Descrição",
          type: "text",
          defaultValue: "",
        },
        {
          name: "ativo",
          label: "Ativo",
          type: "switch",
          options: {
            trueValue: "Sim",
            falseValue: "Não",
          },
          defaultValue: true,
        },
      ],
      filtrosAtivos: JSON.parse(
        localStorage.getItem("filtros.equipamentos") || `{"ativo" : true}`
      ),
      loading: false,
      dialogConfirm: false,
    };
  },
  computed: {
    equipamentos() {
      return this.$store.state.equipamento.Equipamentos;
    },
    perms() {
      return this.$store.state.usuarios.usuarioAtivo.permissoes;
    },
  },
  methods: {
    async deletar(id) {
      this.loading = true;
      await this.$store.dispatch("equipamento/deletar", { id });

      this.listar();
    },
    editar(id) {
      this.$router.replace({
        path: "editar",
        name: "equipamento-formulario-editar",
        params: { id },
      });
    },
    async listar() {
      this.loading = true;
      try {
        await this.$store.dispatch("equipamento/listar", {
          filtros: this.filtrosAtivos,
        });
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
  },
  watch: {
    filtrosAtivos(val) {
      localStorage.setItem("filtros.equipamentos", JSON.stringify(val));
      this.listar();
    },
  },
  mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de equipamentos",
    });
    this.listar();
  },
};
</script>
